var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBell = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03027 15.5166H15.9609C16.7871 15.5166 17.2881 15.0859 17.2881 14.4531C17.2881 13.5742 16.3916 12.7832 15.6357 12.001C15.0557 11.3945 14.8975 10.1465 14.8271 9.13574C14.7656 5.76074 13.8691 3.43164 11.5312 2.58789C11.1973 1.44531 10.292 0.53125 8.99121 0.53125C7.69922 0.53125 6.78516 1.44531 6.45996 2.58789C4.12207 3.43164 3.22559 5.76074 3.16406 9.13574C3.09375 10.1465 2.93555 11.3945 2.35547 12.001C1.59082 12.7832 0.703125 13.5742 0.703125 14.4531C0.703125 15.0859 1.19531 15.5166 2.03027 15.5166ZM8.99121 19.0322C10.4854 19.0322 11.5752 17.9424 11.6895 16.7119H6.30176C6.41602 17.9424 7.50586 19.0322 8.99121 19.0322Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-bell.9d7edddcc6e7fd43b7a5eb170e7e4b18.svg";